import { ROUTES } from '@/router'
import { LinkButton } from '@/ui/Button'
import { InfoCard } from '@/ui/InfoCard'

export const ErrorPage = () => {
    return (
        <InfoCard>
            <h6>Oops! Something unexpected has occurred</h6>
            <p>
                {'Please try refreshing the page. Please contact '}
                <a href={'mailto:servicedesk@goahead.com'}>servicedesk@goahead.com</a>
                {' for any queries.'}
            </p>
            <LinkButton to={ROUTES.LOGIN}>Back to home</LinkButton>
        </InfoCard>
    )
}
